export const RussianSpeakingIcon = ({
  width = '24',
  height = '24',
  fill = '#0F2664',
}) => {
  return (
    <div className="feature">
      <svg
        width={width}
        height={height}
        viewBox="0 1 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width={width} height={height} rx="12" fill="white" />
        <path
          d="M2.47 18V8.2H6.292C7.15067 8.2 7.88333 8.33533 8.49 8.606C9.09667 8.87667 9.56333 9.26867 9.89 9.782C10.2167 10.2953 10.38 10.9067 10.38 11.616C10.38 12.3253 10.2167 12.9367 9.89 13.45C9.56333 13.954 9.09667 14.3413 8.49 14.612C7.88333 14.8827 7.15067 15.018 6.292 15.018H3.24L3.87 14.374V18H2.47ZM9.022 18L6.53 14.444H8.028L10.548 18H9.022ZM3.87 14.514L3.24 13.828H6.25C7.146 13.828 7.82267 13.6367 8.28 13.254C8.74667 12.862 8.98 12.316 8.98 11.616C8.98 10.916 8.74667 10.3747 8.28 9.992C7.82267 9.60933 7.146 9.418 6.25 9.418H3.24L3.87 8.718V14.514ZM17.1219 18.112C15.8339 18.112 14.8212 17.7433 14.0839 17.006C13.3465 16.2687 12.9779 15.1907 12.9779 13.772V8.2H14.3779V13.716C14.3779 14.808 14.6159 15.606 15.0919 16.11C15.5772 16.614 16.2585 16.866 17.1359 16.866C18.0225 16.866 18.7039 16.614 19.1799 16.11C19.6652 15.606 19.9079 14.808 19.9079 13.716V8.2H21.2659V13.772C21.2659 15.1907 20.8972 16.2687 20.1599 17.006C19.4319 17.7433 18.4192 18.112 17.1219 18.112Z"
          fill="#696F79"
        />
      </svg>
    </div>
  );
};
